
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers-get-in-touch",
      function () {
        return require("private-next-pages/job-seekers-get-in-touch/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers-get-in-touch"])
      });
    }
  